import EmployeePerformanceSkillComponents from "../components/EmployeePerformanceSkill";
import useEmployeePerformanceSkill from "../hooks/useEmployeePerformanceSkill";

function EmployeePerformanceSkill() {
  const employeePerformanceSkillProps = useEmployeePerformanceSkill();
  return (
    <EmployeePerformanceSkillComponents {...employeePerformanceSkillProps} />
  );
}

export default EmployeePerformanceSkill;
